import Image from 'next/image'
import Link from 'next/link'

export function Logo() {
  return (
    <Link href="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity">
      <Image
        src="/picone-logo.svg"
        alt="Picone"
        width={32}
        height={32}
        priority
        className="h-8 w-8"
      />
      <span className="text-xl font-display font-semibold text-foreground">
        picone
      </span>
    </Link>
  )
}

